<template>
  <section>
    <v-breadcrumbs v-if="breadcrumbsItems.length" :items="breadcrumbsItems" class="py-2 px-0" divider="/"></v-breadcrumbs>
    <p v-if="showTitle" class="text-h6 my-0">{{ title }}</p>
    <p v-if="subtitle" class="subtitle-1 mb-0">{{ subtitle }}</p>
  </section>
</template>

<script lang="ts">
export default {
  props: {
    title: {
      type: [String, Number],
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    subtitle: [String, Number],
    breadcrumbsItems: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  watch: {
    title: function (newVal) {
      document.title = newVal;
    },
  },
  mounted() {
    if (this.title) {
      document.title = this.title.toString();
    }
  },
};
</script>

<style></style>
